import { useState } from "react";

//Bootstrap
import { Card, Row, Col } from "react-bootstrap";

//Icons
import { MdEdit } from "react-icons/md";

//UI components
import Field from "../../../ui/Field";

//Components
import EditFormClaniceNacrtovano from "./EditFormClaniceNacrtovano";

//Utils
import currencyFormatToEUR from "../../../utils/currencyFormatToEUR";
import tooltipsText from "../../../utils/tooltipsText";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const FinanceClaniceNacrtovanoCardItem = ({ clanica }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { project } = useProjectDetailsContext();

  const onEditClick = () => {
    setIsEditing(true);
  };

  // Format lastno sofinanciranje to include both the value and the percentage in parentheses
  const lastnoSofinanciranjeInDelez = `${currencyFormatToEUR(
    clanica?.nacrtovanaLastnaVrednost,
  )} (${clanica.nacrtovanaDelez ? `${clanica.nacrtovanaDelez}%` : "Ni podatka o deležu"})`;

  return (
    <Card className="mb-3 mt-3">
      <div className="d-flex align-items-center justify-content-between px-3 pt-3">
        <h5 className="mb-0">{clanica?.clanica}</h5>
        {!isEditing && (
          <RoleGuard
            moduleKey={MODULES.PROJEKTI}
            roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
            vodilnaClanicaProjektaID={project?.clanicaID}
          >
            <button
              className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
              onClick={onEditClick}
              disabled={isEditing}
            >
              <span className="d-flex align-items-center gap-1">
                Uredi <MdEdit />
              </span>
            </button>
          </RoleGuard>
        )}
      </div>
      {!isEditing && (
        <div className="px-3 pb-3 pt-2">
          <Row>
            <Col md={5}>
              <Field
                label="Vrednost projekta"
                value={currencyFormatToEUR(clanica?.nacrtovanaVrednost)}
                tooltip={tooltipsText.P41vrednostProjektaZaClanicoUM}
              />
              <Field
                label="Lastno sofinanciranje"
                value={lastnoSofinanciranjeInDelez}
                tooltip={tooltipsText.P41vrednostDelezLastnegaSofinanciranjaUM}
              />
            </Col>
            <Col md={5}>
              <Field
                label="Sofinanciranje iz projektnega vira"
                value={currencyFormatToEUR(clanica?.nacrtovanaVrednostViri)}
                tooltip={
                  tooltipsText.P41vrednostSofinanaciranjaIzProjektnihVirovZaClanicoUM
                }
              />
              <Field
                label="Obseg zaposlitev (Izraženo v FTE)"
                value={
                  clanica?.nacrtovaniObseg
                    ? clanica.nacrtovaniObseg
                    : "Ni podatka"
                }
                tooltip={tooltipsText.P41obsegZaposlitveNaClaniciUM}
              />
            </Col>
          </Row>
        </div>
      )}
      {isEditing && (
        <div className="px-3 pb-3 pt-2">
          <EditFormClaniceNacrtovano
            clanica={clanica}
            setIsEditing={setIsEditing}
          />
        </div>
      )}
    </Card>
  );
};

export default FinanceClaniceNacrtovanoCardItem;
